import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { storage } from "./firebaseConfig";

const STUDENT_QR_DIRECTORY = "student_qr";

export function buildStudentQrStoragePath(uid) {
  return `${STUDENT_QR_DIRECTORY}/${uid}.png`;
}

export async function uploadStudentQrImage({ uid, file, onProgress }) {
  const qrReference = ref(storage, buildStudentQrStoragePath(uid));

  return new Promise((resolve, reject) => {
    const uploadTask = uploadBytesResumable(qrReference, file, {
      contentType: file?.type || "image/png",
      customMetadata: {
        originalFileName: file?.name || `${uid}.png`,
      },
    });

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const totalBytes = snapshot.totalBytes || 1;
        const progress = Math.round(
          (snapshot.bytesTransferred / totalBytes) * 100,
        );
        onProgress?.(progress);
      },
      (error) => reject(error),
      async () => {
        try {
          const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadUrl);
        } catch (error) {
          reject(error);
        }
      },
    );
  });
}

export async function deleteStudentQrImage({ qrImageUrl, uid }) {
  let qrReference;

  try {
    qrReference = qrImageUrl
      ? ref(storage, qrImageUrl)
      : ref(storage, buildStudentQrStoragePath(uid));
  } catch {
    qrReference = ref(storage, buildStudentQrStoragePath(uid));
  }

  try {
    await deleteObject(qrReference);
  } catch (error) {
    if (error?.code !== "storage/object-not-found") {
      throw error;
    }
  }
}
